function getTrimmedOnboardingName(entity_name) {
  return String(entity_name || '').trim();
}

function getOnboardingNameTokens(entity_name) {
  return getTrimmedOnboardingName(entity_name).split(/\s+/).filter(Boolean);
}

function getOnboardingFirstName(name_tokens) {
  return name_tokens[0] || '';
}

function getOnboardingLastName(name_tokens) {
  return name_tokens.slice(1).join(' ');
}

function buildOnboardingNamePartsFromTokens(name_tokens) {
  return {
    first_name: getOnboardingFirstName(name_tokens),
    last_name: getOnboardingLastName(name_tokens)
  };
}

export const buildOnboardingNameParts = (entity_name) =>
  buildOnboardingNamePartsFromTokens(getOnboardingNameTokens(entity_name));
